import React from 'react';
import styles from './CriteriaSidebarEmptyState.module.scss';
import { Button, Heading, Text } from 'components/core';
import { Stack } from 'components/layout';
import {
  IconChecklist,
  IconChecklistItem,
} from 'components/shared/IconChecklist';
import { useReviewSetupLinks } from 'hooks/reviews/useReviewSetupLinks';

const benefits = [
  'Keep your criteria in view while screening',
  'Apply the same criteria to every study',
  'Reduce disagreements and conflicts in your team',
];

// The call to action goes to Review Setup rather than the inline editor, as
// only Review Setup lets a framework be chosen.
export const CriteriaSidebarEmptyState = () => {
  const { eligibilityCriteriaLink } = useReviewSetupLinks();

  return (
    <Stack spacing={3}>
      <Heading type="h5" component="h3">
        Make screening more consistent
      </Heading>
      <Text size="sm">Add your eligibility criteria to:</Text>
      <IconChecklist>
        {benefits.map((benefit) => (
          <IconChecklistItem
            key={benefit}
            iconVariant="success"
            alignY="center"
          >
            <Text size="sm">{benefit}</Text>
          </IconChecklistItem>
        ))}
      </IconChecklist>
      <Button
        type="brand"
        to={eligibilityCriteriaLink}
        external
        className={styles.AddCriteriaButton}
        data-pendo-key="add-criteria-sidebar"
      >
        Add eligibility criteria
      </Button>
    </Stack>
  );
};
